import React from "react";
import Card from "react-bootstrap/Card";
import { Row, Col } from "react-bootstrap";

function QuickWisdomCard(props) {
    return (
        <Card className="quote-card-view">
            <Card.Body>
                <h5 className="purple" style={{ marginBottom: "15px" }}>
                    {props.title}
                </h5>        <blockquote className="blockquote mb-0">
                    <div style={{ textAlign: "justify", marginBottom: "20px" }}>
                        {props.content.split('\n').map((line, index) => (
                            <span key={index}>
                                {line}
                                {index < props.content.split('\n').length - 1 && <br />}
                            </span>
                        ))}
                    </div>
                    <footer className="blockquote-footer" style={{ marginTop: "15px" }}>
                        <cite title="Source Title">{props.category}</cite>
                    </footer>
                </blockquote>
            </Card.Body>
        </Card>
    );
}

function QuickWisdom() {
    const quotes = require("../../Assets/quotes.json");

    return (
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
            {quotes.map((quote, index) => (<Col md={4} className="project-card" key={index}>
                <div id={`quick-wisdom-item-${index}`}>
                    <QuickWisdomCard
                        title={quote.title}
                        content={quote.content}
                        category={quote.category}
                    />
                </div>
            </Col>
            ))}
        </Row>
    );
}

export default QuickWisdom;
